// extracted by mini-css-extract-plugin
export var deleteModal = "_hu-0";